(function(){
  function readConfig(){
    var cfg = window.CCD_CONFIG || {};
    var el = document.getElementById('ccd-ship-wrap');
    if (el) {
      if (!cfg.threshold && el.dataset.threshold) cfg.threshold = parseInt(el.dataset.threshold, 10);
      if (!cfg.currency && el.dataset.currency) cfg.currency = el.dataset.currency;
      if (!cfg.bundleTarget && el.dataset.bundleTarget) cfg.bundleTarget = parseInt(el.dataset.bundleTarget, 10);
      if (!cfg.bundleDiscount && el.dataset.bundleDiscount) cfg.bundleDiscount = el.dataset.bundleDiscount;
      if (cfg.showBundle === undefined) cfg.showBundle = true;
    }
    return cfg;
  }

  var CFG = readConfig();

  function money(cents){
    var cur = CFG.currency || 'GBP';
    try {
      return new Intl.NumberFormat(CFG.lang || 'en-GB', { style:'currency', currency: cur, currencyDisplay:'narrowSymbol' }).format((cents||0)/100);
    } catch(e){
      var symbols = { GBP:'£', USD:'$', EUR:'€', AED:'AED ' };
      return (symbols[cur] || '') + ((cents||0)/100).toFixed(2);
    }
  }
  function esc(s){ var d=document.createElement('div'); d.textContent = s==null?'':s; return d.innerHTML; }
  function img(url){ if(!url) return ''; url=String(url); return url + (url.indexOf('?')>-1?'&':'?') + 'width=300'; }
  function firstAvail(p){ var v=p.variants||[]; for(var i=0;i<v.length;i++){ if(v[i].available) return v[i]; } return v[0]; }
  function toCents(v){ if(typeof v==='number') return v; var s=String(v); var f=parseFloat(s); if(isNaN(f)) return 0; return s.indexOf('.')>-1 ? Math.round(f*100) : f; }
  function imgOf(p){
    var f=p.featured_image;
    if(f) return typeof f==='string'?f:(f.src||'');
    if(p.images&&p.images[0]) return typeof p.images[0]==='string'?p.images[0]:(p.images[0].src||'');
    return '';
  }

  var lastSig = null;

  function updateShip(cart){
    var wrap = document.getElementById('ccd-ship-wrap');
    if(!wrap) return;
    var total = cart.total_price || 0;
    var pct = CFG.threshold>0 ? Math.min((total/CFG.threshold)*100,100) : 100;
    var remaining = Math.max(CFG.threshold - total, 0);
    var fill = document.getElementById('ccd-ship-fill');
    var msg = document.getElementById('ccd-ship-msg');
    var goal = document.getElementById('ccd-ship-goal');
    var icon = document.getElementById('ccd-ship-icon');
    if(fill) fill.style.width = pct + '%';
    if(goal) goal.textContent = money(CFG.threshold);
    if(msg){
      if(remaining<=0){ msg.innerHTML = "🎉 You've unlocked <strong>FREE shipping!</strong>"; if(icon) icon.classList.add('is-complete'); }
      else { msg.innerHTML = "You're <strong>"+money(remaining)+"</strong> away from free shipping!"; if(icon) icon.classList.remove('is-complete'); }
    }
  }

  function updateBundle(cart){
    var root = document.getElementById('ccd-bundle');
    if(!root || !CFG.showBundle) return;
    var wrap = root.closest('.ccd-bundle-wrap');
    if(wrap) wrap.style.display = '';
    var qty = (cart.items||[]).reduce(function(a,i){ return a + (i.quantity||0); }, 0);
    var target = CFG.bundleTarget || 5;
    updateBundleThumbs(cart);
    var remaining = Math.max(target - qty, 0);
    var sub = root.querySelector('.ccd-bundle__sub');
    var offer = root.querySelector('.ccd-bundle__offer');
    var btn = root.querySelector('.ccd-bundle__btn');
    if(remaining<=0){
      root.classList.add('is-unlocked');
      if(sub) sub.textContent = "🎉 You've unlocked " + CFG.bundleDiscount + " off your order!";
      return;
    }
    root.classList.remove('is-unlocked');
    var offerHtml = "<b>"+CFG.bundleDiscount+" OFF</b> when you add "+remaining+" more";
    if(sub && sub.innerHTML !== offerHtml) sub.innerHTML = offerHtml;
    if(offer) offer.innerHTML = '';
    var btnTxt = "Add " + remaining + " more";
    if(btn){ if(btn.textContent !== btnTxt) btn.textContent = btnTxt; btn.dataset.remaining = remaining; btn.disabled = false; }
  }

  var recoRendered = false;
  function updateBundleThumbs(cart){
    var thumbs = document.querySelector('#ccd-bundle .ccd-bundle__thumbs');
    if(!thumbs) return;
    var items = (cart.items||[]).slice(0, 4);
    var html = items.map(function(it){
      var src = it.image ? (it.image.indexOf('?')>-1 ? it.image+'&width=120' : it.image+'?width=120') : '';
      return '<div class="ccd-bundle__thumb"><img src="'+esc(src)+'" alt="'+esc(it.title)+'" loading="lazy"></div>';
    }).join('');
    html += '<div class="ccd-bundle__plus">+</div>';
    if(thumbs.innerHTML !== html) thumbs.innerHTML = html;
  }

  function renderReco(products){
    var wrap = document.getElementById('ccd-reco-wrap');
    var scroller = document.getElementById('ccd-reco-scroller');
    if(!wrap || !scroller) return;
    if(!products || !products.length){ if(!recoRendered) wrap.style.display='none'; return; }
    wrap.style.display='';
    recoRendered = true;
    var html='';
    products.forEach(function(p){
      var vs = p.variants || [];
      var v = firstAvail(p); if(!v) return;
      var price = toCents(v.price != null ? v.price : p.price);
      var sel = '';
      if(vs.length > 1){
        sel = '<select class="ccd-reco__select">';
        vs.forEach(function(vv){
          sel += '<option value="'+vv.id+'" data-price="'+toCents(vv.price)+'"'+(vv.available?'':' disabled')+(vv.id===v.id?' selected':'')+'>'+esc(vv.title)+(vv.available?'':' — sold out')+'</option>';
        });
        sel += '</select>';
      }
      html += '<div class="ccd-reco__card">'
        + '<a class="ccd-reco__img" href="'+esc(p.url||('/products/'+p.handle))+'"><img src="'+esc(img(imgOf(p)))+'" alt="'+esc(p.title)+'" loading="lazy"></a>'
        + '<div class="ccd-reco__name">'+esc(p.title)+'</div>'
        + '<div class="ccd-reco__price">'+money(price)+'</div>'
        + sel
        + '<button type="button" class="ccd-reco__add" data-variant="'+v.id+'">'+esc(CFG.addLabel)+'</button>'
        + '</div>';
    });
    scroller.innerHTML = html;
  }

  var lastRecoFirst = null;
  function loadReco(cart){
    var wrap = document.getElementById('ccd-reco-wrap');
    if(!wrap || !CFG.showReco) return;
    var first = (cart.items||[])[0];
    var firstId = first ? first.product_id : null;
    var scroller = document.getElementById('ccd-reco-scroller');
    var hasCards = scroller && scroller.querySelector('.ccd-reco__card');
    if(hasCards && firstId === lastRecoFirst) return;
    lastRecoFirst = firstId;
    var url;
    var inCart = (cart.items||[]).map(function(i){ return i.product_id; });
    function draw(list){
      var products = (list||[]).filter(function(p){ return inCart.indexOf(p.id)===-1; }).slice(0, CFG.recoCount);
      if(products.length){ renderReco(products); }
      else { fallback(); }
    }
    function fallback(){
      var furl = CFG.recoCollection
        ? '/collections/'+CFG.recoCollection+'/products.json?limit='+(CFG.recoCount+4)
        : '/collections/all/products.json?limit='+(CFG.recoCount+4);
      fetch(furl).then(function(r){ return r.json(); }).then(function(d){
        var products = (d.products||[]).filter(function(p){ return inCart.indexOf(p.id)===-1; }).slice(0, CFG.recoCount);
        if(products.length) renderReco(products); else wrap.style.display='none';
      }).catch(function(){ wrap.style.display='none'; });
    }

    if(CFG.recoSource==='collection' && CFG.recoCollection){
      fetch('/collections/'+CFG.recoCollection+'/products.json?limit='+(CFG.recoCount+4))
        .then(function(r){ return r.json(); }).then(function(d){ draw(d.products); }).catch(fallback);
    } else if(first){
      fetch('/recommendations/products.json?product_id='+first.product_id+'&intent=related&limit='+CFG.recoCount)
        .then(function(r){ return r.json(); }).then(function(d){ draw(d.products); }).catch(fallback);
    } else {
      fallback();
    }
    return;
  }

  function updateTotal(cart){
    var total = cart.total_price || 0;
    var cur = CFG.currency || 'GBP';
    document.querySelectorAll('.cart-totals__total-value').forEach(function(el){
      var withCode = /\b[A-Z]{3}\s*$/.test(el.textContent.trim());
      var txt = money(total) + (withCode ? ' ' + cur : '');
      el.textContent = txt;
      el.setAttribute('value', txt);
    });
  }

  function refreshAll(cart){
    CFG = readConfig();
    dedupe();
    updateShip(cart);
    updateBundle(cart);
    updateCartBubble(cart);
    updateTotal(cart);
  }

  function getCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }); }

  function syncFromCart(reloadReco){
    return getCart().then(function(cart){
      var sig = cart.item_count + ':' + cart.total_price;
      if(sig === lastSig && !reloadReco) return cart;
      lastSig = sig;
      refreshAll(cart);
      return cart;
    }).catch(function(e){ console.log('CCD sync error', e); });
  }

  function dispatchCartRefresh(cart){
    try {
      if(typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined' && PUB_SUB_EVENTS.cartUpdate){
        publish(PUB_SUB_EVENTS.cartUpdate, { source:'ccd', cartData: cart });
      }
    } catch(e){}
  }

  function refreshNative(){
    var drawer = document.querySelector('cart-drawer-component, cart-drawer, #cart-drawer, [id*="cart-drawer" i]');
    var section = drawer && drawer.closest('.shopify-section');
    var id = section && section.id ? section.id.replace('shopify-section-','') : null;
    var url = id ? ('/?section_id='+encodeURIComponent(id)) : '/?sections=cart-drawer';
    return fetch(url).then(function(r){ return r.text(); }).then(function(txt){
      var htmlStr = txt;
      if(txt.charAt(0)==='{'){ try { var j=JSON.parse(txt); htmlStr = j[id] || j['cart-drawer'] || ''; } catch(e){ htmlStr=''; } }
      if(!htmlStr) return;
      var doc = new DOMParser().parseFromString(htmlStr, 'text/html');
      ['.cart-items','cart-drawer-items','[id*="CartDrawer-CartItems" i]','.drawer__contents .cart-items'].some(function(sel){
        var src = doc.querySelector(sel), dst = document.querySelector(sel);
        if(src && dst){ dst.innerHTML = src.innerHTML; return true; }
        return false;
      });
      var st = doc.querySelector('.totals,[class*="totals"]');
      var stC = document.querySelector('.totals,[class*="totals"]');
      if(st && stC) stC.innerHTML = st.innerHTML;
    }).catch(function(){});
  }

  function addItems(items){
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items: items, sections: getSectionsToRender(), sections_url: window.location.pathname })
    }).then(function(r){
      return r.json().then(function(data){
        if(!r.ok){
          var err = new Error(data.description || data.message || 'Add to cart failed');
          err.handled = true;
          throw err;
        }
        return data;
      });
    }).then(function(added){
      return getCart().then(function(cart){
        lastSig = null;
        refreshAll(cart);
        updateCartBubble(cart);
        notifyHorizon(added, cart);
        return cart;
      });
    });
  }

  function updateCartBubble(cart){
    var count = cart.item_count || 0;
    document.querySelectorAll('.cart-bubble__text-count').forEach(function(el){
      el.textContent = count;
    });
    document.querySelectorAll('.cart-bubble').forEach(function(b){
      b.hidden = count === 0;
      b.classList.toggle('cart-bubble--visible', count > 0);
    });
  }

  function getSectionsToRender(){
    var ids = [];
    document.querySelectorAll('cart-drawer-component, [id^="shopify-section"]').forEach(function(el){
      var sec = el.closest('.shopify-section');
      if(sec && sec.id){ var id = sec.id.replace('shopify-section-',''); if(ids.indexOf(id)===-1) ids.push(id); }
    });
    return ids;
  }

  function notifyHorizon(added, cart){
    try {
      if(typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined' && PUB_SUB_EVENTS.cartUpdate){
        publish(PUB_SUB_EVENTS.cartUpdate, { source:'ccd-add', cartData: cart, productVariantId: added && added.items && added.items[0] && added.items[0].variant_id });
      }
    } catch(e){}
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
    } catch(e){}
    try {
      var evt = new CustomEvent('cart-items:refresh', { bubbles:true });
      var comp = document.querySelector('cart-items-component');
      if(comp) comp.dispatchEvent(evt);
    } catch(e){}
    refreshDrawerItems();
  }

  function refreshDrawerItems(){
    var comp = document.querySelector('cart-items-component');
    var sec = comp && comp.closest('.shopify-section');
    var id = sec && sec.id ? sec.id.replace('shopify-section-','') : null;
    var url = id ? ('/?section_id='+encodeURIComponent(id)) : null;
    if(!url) return;
    fetch(url).then(function(r){ return r.text(); }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newComp = doc.querySelector('cart-items-component');
      if(!newComp || !comp) return;
      var newItems = newComp.querySelector('.cart-items__wrapper');
      var curItems = comp.querySelector('.cart-items__wrapper');
      if(newItems && curItems){ curItems.innerHTML = newItems.innerHTML; }
      // total handled by updateTotal from cart data
      lastSig = null;
      getCart().then(function(c){ refreshAll(c); });
    }).catch(function(){});
  }

  function guardScroller(){}

  if(!window.CCD_DRAG_BOUND){
  window.CCD_DRAG_BOUND = true;
  (function(){
    var el=null, startX=0, startScroll=0, moved=false, pid=null;

    document.addEventListener('dragstart', function(e){
      if(e.target.closest && e.target.closest('.ccd-reco__scroller')) e.preventDefault();
    }, true);

    document.addEventListener('pointerdown', function(e){
      if(e.pointerType !== 'mouse') return;
      if(e.button !== 0) return;
      var t = e.target;
      if(!t || !t.closest) return;
      var sc = t.closest('.ccd-reco__scroller');
      if(!sc) return;
      if(t.closest('.ccd-reco__add, .ccd-reco__select')) return;

      el = sc; pid = e.pointerId;
      startX = e.clientX; startScroll = sc.scrollLeft; moved = false;
      e.preventDefault();
    }, true);

    document.addEventListener('pointermove', function(e){
      if(!el || e.pointerId !== pid) return;
      var dx = e.clientX - startX;
      if(!moved && Math.abs(dx) > 4){
        moved = true;
        el.classList.add('is-dragging');
        try { el.setPointerCapture(pid); } catch(err){}
      }
      if(moved){
        el.scrollLeft = startScroll - dx;
        e.preventDefault();
      }
    }, true);

    function endDrag(e){
      if(!el) return;
      if(e && e.pointerId != null && e.pointerId !== pid) return;
      try { el.releasePointerCapture(pid); } catch(err){}
      el.classList.remove('is-dragging');
      var wasMoved = moved;
      el = null; pid = null;
      if(wasMoved) setTimeout(function(){ moved = false; }, 0);
    }

    document.addEventListener('pointerup', endDrag, true);
    document.addEventListener('pointercancel', endDrag, true);
    window.addEventListener('blur', function(){ endDrag(); });

    document.addEventListener('click', function(e){
      if(moved && e.target.closest && e.target.closest('.ccd-reco__scroller')){
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
  })();
  }

  if(!window.CCD_HANDLERS_BOUND){
  window.CCD_HANDLERS_BOUND = true;

  document.addEventListener('click', function(e){
    var add = e.target.closest('.ccd-reco__add');
    if(add){
      if(e.__ccdHandled) return;
      e.__ccdHandled = true;
      e.preventDefault();
      var card = add.closest('.ccd-reco__card');
      var selEl = card && card.querySelector('.ccd-reco__select');
      var vid = parseInt(selEl ? selEl.value : add.dataset.variant, 10);
      if(!vid) return;
      add.disabled = true; var t = add.textContent; add.textContent = 'Adding...';
      addItems([{ id: vid, quantity: 1 }]).then(function(){
        add.textContent = 'Added'; setTimeout(function(){ add.disabled=false; add.textContent=t; }, 1400);
      }).catch(function(){ add.disabled=false; add.textContent=t; });
      return;
    }
    var bbtn = e.target.closest('.ccd-bundle__btn, .ccd-bundle__plus');
    if(bbtn){
      e.preventDefault();
      openPicker();
      return;
    }
    if(e.target.closest('[data-picker-close]')){ closePicker(); return; }
    if(e.target.closest('.ccd-picker__select')) return;
    var pitem = e.target.closest('.ccd-picker__item');
    if(pitem){
      if(e.__ccdHandled) return;
      e.__ccdHandled = true;
      pitem.classList.toggle('selected');
      updatePickerCount();
      return;
    }
    var padd = e.target.closest('.ccd-picker__add');
    if(padd){
      e.preventDefault();
      var openPickerEl = padd.closest('.ccd-picker');
      var chosen = [].slice.call(openPickerEl.querySelectorAll('.ccd-picker__item.selected'));
      if(!chosen.length) return;
      var items = chosen.map(function(el){
        var vsel = el.querySelector('.ccd-picker__select');
        var vid = vsel ? parseInt(vsel.value,10) : parseInt(el.dataset.variant,10);
        return { id: vid, quantity: 1 };
      });
      padd.disabled = true; padd.textContent = 'Adding...';
      addItems(items).then(function(){ closePicker(); padd.textContent='Add selected'; })
        .catch(function(){ padd.disabled=false; padd.textContent='Add selected'; });
      return;
    }
  });

  document.addEventListener('change', function(e){
    var psel = e.target.closest('.ccd-picker__select');
    if(psel){
      var pitem = psel.closest('.ccd-picker__item');
      var popt = psel.options[psel.selectedIndex];
      var ppriceEl = pitem && pitem.querySelector('.ccd-picker__item-price');
      if(ppriceEl && popt){ ppriceEl.textContent = money(parseInt(popt.getAttribute('data-price'),10)); }
      if(pitem && !pitem.classList.contains('selected')){
        pitem.classList.add('selected');
        updatePickerCount();
      }
      return;
    }
    var sel = e.target.closest('.ccd-reco__select');
    if(!sel) return;
    var card = sel.closest('.ccd-reco__card');
    var opt = sel.options[sel.selectedIndex];
    var priceEl = card && card.querySelector('.ccd-reco__price');
    if(priceEl && opt){ priceEl.textContent = money(parseInt(opt.getAttribute('data-price'),10)); }
  });

  }

  function bindObservers(){
    try {
      if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined'){
        if(PUB_SUB_EVENTS.cartUpdate){
          subscribe(PUB_SUB_EVENTS.cartUpdate, function(ev){
            if(ev && ev.source==='ccd') return;
            lastSig=null;
            if(ev && ev.cartData){ dedupe(); refreshAll(ev.cartData); }
            else syncFromCart(true);
          });
        }
        if(PUB_SUB_EVENTS.cartError){
          subscribe(PUB_SUB_EVENTS.cartError, function(){ lastSig=null; syncFromCart(true); });
        }
      }
    } catch(e){}

    ['cart:refresh','cart:updated','CartAddEvent','cart-add','variant:add'].forEach(function(name){
      document.addEventListener(name, function(){ lastSig=null; syncFromCart(true); });
    });

    var drawer = document.querySelector('cart-drawer-component');
    if(drawer){
      ['dialog:open','DialogOpenEvent','dialog:after-show','toggle'].forEach(function(n){
        drawer.addEventListener(n, function(){ lastSig=null; setTimeout(function(){ syncFromCart(true); }, 60); });
      });
      var dlg = drawer.querySelector('dialog');
      if(dlg){
        var wasOpen = dlg.open;
        var mo = new MutationObserver(function(){
          if(dlg.open && !wasOpen){ wasOpen=true; lastSig=null; syncFromCart(true); }
          else if(!dlg.open){ wasOpen=false; }
        });
        mo.observe(dlg, { attributes:true, attributeFilter:['open'] });
      }
    }

    var itemsComp = document.querySelector('cart-items-component');
    if(itemsComp){
      var repaintDeb, repainting=false;
      var rmo = new MutationObserver(function(muts){
        var onlyCcd = muts.every(function(m){
          return m.target && m.target.closest && m.target.closest('.ccd');
        });
        if(onlyCcd) return;
        var msg = document.getElementById('ccd-ship-msg');
        var barEmpty = msg && msg.textContent.trim()==='';
        if(!barEmpty) return;
        if(repainting) return;
        clearTimeout(repaintDeb);
        repaintDeb = setTimeout(function(){
          repainting = true;
          getCart().then(function(cart){
            refreshAll(cart);
            setTimeout(function(){ repainting=false; }, 500);
          });
        }, 250);
      });
      rmo.observe(itemsComp, { childList:true, subtree:true });
    }
  }

  var PICKER_HTML = null;

  function cachePickerHtml(){
    var p = document.getElementById('ccd-picker');
    if(p && !PICKER_HTML){ PICKER_HTML = p.outerHTML; }
  }

  function ensurePicker(){
    var picker = document.getElementById('ccd-picker');
    if(picker) return picker;
    if(!PICKER_HTML) return null;
    var host = document.querySelector('cart-drawer-component dialog') || document.querySelector('cart-drawer-component') || document.body;
    var tmp = document.createElement('div');
    tmp.innerHTML = PICKER_HTML;
    picker = tmp.firstElementChild;
    if(picker){ picker.hidden = true; host.appendChild(picker); }
    return picker;
  }

  function openPicker(){
    var root = document.getElementById('ccd-bundle');
    if(!root) return;
    cachePickerHtml();
    var picker = ensurePicker();
    if(!picker) return;
    var list = picker.querySelector('.ccd-picker__list');
    if(!list) return;
    var drawerEl = document.querySelector('cart-drawer-component dialog') || document.querySelector('cart-drawer-component');
    if(drawerEl && picker.parentNode !== drawerEl){ drawerEl.appendChild(picker); }
    var products = [];
    try { products = JSON.parse(root.getAttribute('data-bundle-products')||'[]'); } catch(e){ products = []; }
    getCart().then(function(cart){
      var inCart = (cart.items||[]).map(function(i){ return i.product_id; });
      var avail = products.filter(function(p){ return p.available && inCart.indexOf(p.id)===-1; });
      if(!avail.length){ list.innerHTML = '<p style="text-align:center;padding:20px;color:#666;font-size:13px;">No more products to add.</p>'; }
      else {
        list.innerHTML = avail.map(function(p){
          var vs = p.variants || [];
          var sel = '';
          if(vs.length > 1){
            sel = '<select class="ccd-picker__select">';
            vs.forEach(function(vv){
              sel += '<option value="'+vv.id+'" data-price="'+vv.price+'"'+(vv.available?'':' disabled')+(vv.id===p.variant_id?' selected':'')+'>'+esc(vv.title)+(vv.available?'':' — sold out')+'</option>';
            });
            sel += '</select>';
          }
          return '<div class="ccd-picker__item" data-variant="'+p.variant_id+'">'
            + '<img class="ccd-picker__item-img" src="'+p.image+'" alt="'+esc(p.title)+'" loading="lazy">'
            + '<div class="ccd-picker__item-info">'
            + (p.origin ? '<div class="ccd-picker__item-origin">'+esc(p.origin)+'</div>' : '')
            + '<div class="ccd-picker__item-title">'+esc(p.title)+'</div>'
            + '<div class="ccd-picker__item-price">'+money(p.price)+'</div>'
            + sel
            + '</div>'
            + '<span class="ccd-picker__check">'
            + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>'
            + '</span></div>';
        }).join('');
      }
      updatePickerCount();
      picker.hidden = false;
    });
  }
  function closePicker(){
    var els = document.querySelectorAll('#ccd-picker');
    for(var i=0;i<els.length;i++){ els[i].hidden = true; }
  }
  function updatePickerCount(){
    var picker = document.querySelector('.ccd-picker:not([hidden])') || document.getElementById('ccd-picker');
    if(!picker) return;
    var n = picker.querySelectorAll('.ccd-picker__item.selected').length;
    var c = picker.querySelector('.ccd-picker__count');
    var b = picker.querySelector('.ccd-picker__add');
    if(c) c.textContent = n + ' selected';
    if(b) b.disabled = n === 0;
  }

  function dedupe(){
    document.querySelectorAll('.ccd').forEach(function(el){
      if(!el.closest('cart-drawer-component') && el.closest('header, .header, header-component, [id^="shopify-section-sections--"][id*="header"]')){
        el.parentNode && el.parentNode.removeChild(el);
      }
    });
    ['ccd-ship-wrap','ccd-bundle','ccd-reco-wrap','ccd-picker'].forEach(function(id){
      var els = document.querySelectorAll('#'+id);
      if(els.length < 2) return;
      var keep = null;
      els.forEach(function(el){ if(el.closest('cart-drawer-component')){ keep = keep || el; } });
      keep = keep || els[0];
      els.forEach(function(el){ if(el !== keep){ el.parentNode && el.parentNode.removeChild(el); } });
    });
  }
  function init(){
    dedupe();
    cachePickerHtml();
    if(document.getElementById('ccd-ship-wrap') || document.getElementById('ccd-bundle') || document.getElementById('ccd-reco-wrap')){
      syncFromCart(true);
      bindObservers();
      setTimeout(function(){ syncFromCart(true); }, 400);
      setTimeout(function(){ syncFromCart(true); }, 1000);
    } else {
      setTimeout(init, 300);
    }
  }

  if(!window.CCD_BOUND){
    window.CCD_BOUND = true;
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', function(){ lastSig=null; setTimeout(function(){ init(); }, 100); });
  } else {
    lastSig = null;
    setTimeout(init, 100);
  }
})();
